import 'css-chunksrc/client/scenes/taskCreation/taskCreationForm/participantsList/resource/user/styles.scss';export default {
  "resource": "_resource_wpkd9_1",
  "user": "_user_wpkd9_12",
  "avatar": "_avatar_wpkd9_24",
  "name": "_name_wpkd9_36",
  "title": "_title_wpkd9_42"
};